import { createAction } from '/@/store/utils';

export const setVersionLabel = createAction('MAPS:SET_VERSION_LABEL');
